module.exports = __webpack_public_path__ + "static/OpeningHours-870df60b6741451be6e5268b7323e70e.png";